const mapboxgl = require("mapbox-gl");
const segmentInsert = require("@mapbox/segmentio-insert");
const eating = require("./data/bcn-eating.geojson");
const nightlife = require("./data/bcn-nightlife.geojson");
const shopping = require("./data/bcn-shopping.geojson");
const sightseeing = require("./data/bcn-sightseeing.geojson");
const RBush = require("rbush");
const turf = require("@turf/helpers");
const destination = require("@turf/destination").default;
const distance = require("@turf/distance").default;

mapboxgl.accessToken = "pk.eyJ1IjoibGFicy1zYW5kYm94IiwiYSI6ImNrMTZuanRodDAxczYzb3BhdWthamppZzIifQ.pcR4XvVDB9yplQVun1diJQ";
const analytics = segmentInsert("fl0c8p240n");
analytics.track("Demo Viewed", {
  name: "heatmap"
});

const map = new mapboxgl.Map({
  container: "map",
  style: "mapbox://styles/labs-sandbox/ck2xli19r2p6p1cpjpgwi82mw?fresh=true",
  center: [2.172, 41.391],
  zoom: 12,
  minZoom: 11,
  dragRotate: false
});


const POIData = {};
const tempData = {};
let hotel = "";

map.on("style.load", () => {
  map.addSource("heatmap", {
    type: "geojson",
    data: {
      "type": "FeatureCollection",
      "features": []
    }
  });

  map.addSource("searchbox", {
    type: "geojson",
    data: {
      "type": "FeatureCollection",
      "features": []
    }
  });

  map.addSource("nearby", {
    type: "geojson",
    data: {
      "type": "FeatureCollection",
      "features": []
    }
  });

  map.addLayer({
    "id": "heatmap",
    "type": "heatmap",
    "source": "heatmap",
    "maxzoom": 22,
    "paint": {
      "heatmap-intensity": [
        "interpolate",
        ["exponential", 1],
        ["zoom"],
        11,
        0.4,
        16,
        0.8
      ],
      // Color ramp for heatmap.  Domain is 0 (low) to 1 (high)
      "heatmap-color": [
        "interpolate",
        ["linear"],
        ["heatmap-density"],
        0, "rgba(0, 0, 0, 0)",
        0.25, "rgba(0,185,243,0.25)",
        0.5, "rgba(0,185,243,0.5)",
        0.75, "rgba(255,223,0,0.75)",
        1, "rgba(255,105,0,1)"
      ],
      // Adjust the heatmap radius by zoom level
      "heatmap-radius": [
        "interpolate",
        ["exponential", 1],
        ["zoom"],
        0,
        1,
        11,
        14,
        16,
        50
      ],
      "heatmap-opacity": [
        "interpolate",
        ["exponential", 1],
        ["zoom"],
        11,
        1,
        15,
        0.5,
        16,
        0
      ]
    }
  }, "waterway-label");

  map.addLayer({
    "id": "searchbox",
    "type": "fill",
    "source": "searchbox",
    "paint": {
      "fill-opacity": {
        stops: [
          [12.5, 1],
          [14, 1]
        ]
      },
      "fill-color": "#F1CFC8"
    }
  }, "water");

  map.addLayer({
    id: "nearby",
    type: "circle",
    source: "nearby",
    paint: {
      "circle-color": "blue",
      "circle-opacity": 1,
      "circle-radius": {
        stops: [
          [12, 1],
          [14, 3.5]
        ]
      }
    }
  });


  map.on("click", highlightNearbyFeatures);
  map.on("click", zoomToFeature);

  // Load in heatmap data and sort it into an R-Tree for fast retreival
  fetch(eating).then(res => res.json()).then(data => {
    const tree = new RBush(9, ['["geometry"]["coordinates"][0]', '["geometry"]["coordinates"][1]', '["geometry"]["coordinates"][0]', '["geometry"]["coordinates"][1]']);
    tree.load(data.features);
    POIData["Eating"] = tree;
    tempData["Eating"] = data;
    if (isDataReady()) map.getSource("heatmap").setData(data);
  });
  fetch(nightlife).then(res => res.json()).then(data => {
    const tree = new RBush(9, ['["geometry"]["coordinates"][0]', '["geometry"]["coordinates"][1]', '["geometry"]["coordinates"][0]', '["geometry"]["coordinates"][1]']);
    tree.load(data.features);
    POIData["Nightlife"] = tree;
    if (isDataReady()) map.getSource("heatmap").setData(data);
    tempData["Nightlife"] = data;
  });
  fetch(shopping).then(res => res.json()).then(data => {
    const tree = new RBush(9, ['["geometry"]["coordinates"][0]', '["geometry"]["coordinates"][1]', '["geometry"]["coordinates"][0]', '["geometry"]["coordinates"][1]']);
    tree.load(data.features);
    POIData["Shopping"] = tree;
    if (isDataReady()) map.getSource("heatmap").setData(data);
    tempData["Shopping"] = data;
  });
  fetch(sightseeing).then(res => res.json()).then(data => {
    const tree = new RBush(9, ['["geometry"]["coordinates"][0]', '["geometry"]["coordinates"][1]', '["geometry"]["coordinates"][0]', '["geometry"]["coordinates"][1]']);
    tree.load(data.features);
    POIData["Sightseeing"] = tree;
    if (isDataReady()) map.getSource("heatmap").setData(data);
    tempData["Sightseeing"] = data;
  });
});


function isDataReady() {
  if (POIData["Shopping"] != null && POIData["Eating"] != null && POIData["Sightseeing"] != null && POIData["Nightlife"] != null) {
    return true;
  }
  return false;
}

const layerFilterElements = document.getElementsByClassName("layerFilter");
Array.prototype.filter.call(layerFilterElements, el => {
  el.addEventListener("change", ele => {
    map.getSource("heatmap").setData(tempData[ele.target.id.replace("Check", "")]);
  });
});

// Hotel UI
const popup = new mapboxgl.Popup({
  closeButton: false,
  closeOnClick: false
});

map.on("mouseenter", "Hotels", () => {
  map.getCanvas().style.cursor = "pointer";
});

map.on("mouseleave", "Hotels", () => {
  map.getCanvas().style.cursor = "pointer";
});

function zoomToFeature(e) {
  const hotels = map.queryRenderedFeatures([
    [e.point.x - 5, e.point.y - 5],
    [e.point.x + 5, e.point.y + 5]
  ], { layers: ["Hotels"] });

  if (hotels.length > 0) {
    hotel = hotels[0];
    map.flyTo({
      center: hotel.geometry.coordinates,
      zoom: 15,
      duration: 1000
    });
  }
}

function highlightNearbyFeatures(e) {
  const hotels = map.queryRenderedFeatures([
    [e.point.x - 5, e.point.y - 5],
    [e.point.x + 5, e.point.y + 5]
  ], { layers: ["Hotels"] });

  map.getCanvas().style.cursor = (hotels.length) ? "pointer" : "";

  if (hotels.length > 0) {
    hotel = hotels[0];

    // Get nearby POIs
    // Build a list of layer names based on the checkboxes

    const layerNames = [];
    const layerFilterElements = document.getElementsByClassName("layerFilter");
    Array.prototype.filter.call(layerFilterElements, el => {
      if (el.checked) {
        layerNames.push(el.getAttribute("data-layer"));
      }
    });

    const buffer = pointBuffer(hotel, 0.5, "kilometers", 50);
    map.getSource("searchbox").setData(buffer);

    const pois = map.queryRenderedFeatures({ layers: layerNames });
    const nearby = [];
    pois.forEach(p => {
      if (distance(p, hotel) <= 0.5) {
        nearby.push(p);
      }
    });

    map.getSource("nearby").setData(turf.featureCollection(nearby));
    map.setPaintProperty("nearby", "circle-opacity", 0.5);


    popup.setLngLat(hotel.geometry.coordinates)
      .setHTML(`Sample Location Name ★★★★☆ Excellent (1,234 reviews) ${nearby.length} attractions nearby.`)
      .addTo(map);
  } else {
    const buffer = pointBuffer(turf.point([0, 0]), 0.5, "kilometers", 3);
    map.getSource("searchbox").setData(buffer);
    map.setPaintProperty("nearby", "circle-opacity", 0);
    popup.remove();
  }
}

function pointBuffer (pt, radius, units, resolution) {
  const ring = [];
  const resMultiple = 360 / resolution;
  for (let i  = 0; i < resolution; i++) {
    const spoke = destination(pt, radius, i * resMultiple, units);
    ring.push(spoke.geometry.coordinates);
  }
  if ((ring[0][0] !== ring[ring.length - 1][0]) && (ring[0][1] !== ring[ring.length - 1][1])) {
    ring.push([ring[0][0], ring[0][1]]);
  }

  return turf.polygon([ring]);
}
